import { Clear, Home } from "@mui/icons-material";
import {
	Checkbox,
	FormControl,
	FormControlLabel,
	FormHelperText,
	FormLabel,
	MenuItem,
	TextField,
	Typography
} from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Link from "@mui/material/Link";
import axios from "axios";
import { ErrorMessage, FormikProvider, useFormik } from "formik";
import { enqueueSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
import {useHistory, useParams} from "react-router-dom";
import * as yup from "yup";
import { getEndPoint } from "../../../../helpers/constants";
import { handleAxiosErrors } from "../../../../helpers/errorHandling";
import { getRouteUrl } from "../../../../helpers/routing/getRouteUrl";
import ReCAPTCHA from "react-google-recaptcha";
import { ROUTE_PAGE_HOME, ROUTE_VERIFICATION } from "../../../../routers/routes";
import useUserData from "../../../../hooks/user/useUserData";
import {useUser} from "../../../../userContext/userContext";
import {PAGE_APPLICATIONS, PAGE_LOGIN} from "../../../../locales/pages/namespaces";
import {useState} from "react";
import {LoadingButton} from "@mui/lab";



const whiteInputProps = {
	variant: "standard",
	InputProps: {
		disableUnderline: true,
		sx: {
			color: "#fff",
			fontSize: 15,
			borderBottom: "1px solid rgba(255,255,255,0.7)",
			"& input": {
				color: "#fff",
			},

			pb: 0.5,
			"& input::placeholder": {
				color: "rgba(255,255,255,0.6)"
			},
			"&:hover": {
				borderBottom: "1px solid #fff"
			}
		}
	}
};
const Form = () => {
	const {campaign} = useParams()
	const {setChangePassId,setChangePassMail,setVerificationId} = useUser()
	const { t, i18n } = useTranslation(PAGE_LOGIN);
	const [loading,setLoading]= useState(false)
	const {language} = useUserData()
	const history = useHistory();
	const validationSchema = yup.object({
		title: yup.string().required(t("Required")),
		firstName: yup.string().required(t("Required")),
		lastName: yup.string().required(t("Required")),
		email: yup.string().email(t("Invalid email")).required(t("Required")),
		mobile: yup.string().required(t("Required")),
		termsofuseagreed: yup.boolean().oneOf([true], t("Required")),
		recaptcha: yup.string().required(t("Please verify that you are not a robot"))
	});

	const formik = useFormik({
		initialValues: {
			title: "",
			firstName: "",
			lastName: "",
			email: "",
			mobile: "",
			signupforsnfnews: false,
			termsofuseagreed: false,
			recaptcha: "",
			portal_version:language
		},
		validationSchema,
		onSubmit: onSubmit
	});

	function onSubmit(values) {
		const payload = {
			...values,
			signupforsnfnews: values.signupforsnfnews ? 1 : 0,
			termsofuseagreed: values.termsofuseagreed ? 1 : 0,
		};
setLoading(true)
		axios({
			method: 'post',
			url: getEndPoint('applicantRegistration'),
			data: payload,
			headers: { 'Content-Type': 'application/json' },
		})
			.then((response) => {
				const verId = response.data.DATABASE.id
				const senderMail = response.data.DATABASE.email
				setChangePassId(verId)
				setVerificationId(verId)
				setChangePassMail(senderMail)
				setLoading(false)
				history.push(getRouteUrl(ROUTE_VERIFICATION, { campaign }));
			})
			.catch((error) => {
				setLoading(false)
				enqueueSnackbar(t("Registration failed!"), {
					variant: 'error',
				});
			});
	}


	const titles = [
		{ id: "Mr", Description: t("Mr") },
		{ id: "Mrs", Description: t("Mrs") },
		{ id: "Other", Description: t("Other") }
	];


	return (
		<FormikProvider value={formik}>
			<Box
				sx={{
					padding: { xs: "10px 20px", sm: "20px 40px", md: "40px" },
					width: "100%"
				}}
				component="form"
				onSubmit={formik.handleSubmit}
				noValidate
			>
				<FormControl fullWidth sx={{ mb: 3 }}>
					<FormLabel sx={{ color: "#fff" }} required>
						{t("Title")}
					</FormLabel>

					<TextField
						select
						variant="standard"
						name="title"
						value={formik.values.title}
						onChange={formik.handleChange}
						SelectProps={{
							disableUnderline: true,
							sx: {
								color: "#fff",
								borderBottom: "1px solid rgba(255,255,255,0.7)",
								"& .MuiSelect-icon": { color: "#fff" },
								"&:hover": { borderBottom: "1px solid #fff" },
								"& .MuiSelect-select": {
									color: "#fff",
								},
							}
						}}
					>
						{titles.map(option => (
							<MenuItem key={option.id} value={option.id}>
								{option.Description}
							</MenuItem>
						))}
					</TextField>

					<FormHelperText sx={{ color: "#ffd1d1" }}>
						<ErrorMessage name="title" />
					</FormHelperText>
				</FormControl>
				<FormControl fullWidth sx={{ mb: 3 }}>
					<FormLabel sx={{ color: "#fff" }} required>
						{t("First Name")}
					</FormLabel>

					<TextField
						{...whiteInputProps}
						name="firstName"
						value={formik.values.firstName}
						placeholder={t("Only Greek/English up to 50 characters")}
						onChange={formik.handleChange}
					/>

					<FormHelperText sx={{ color: "#ffd1d1" }}>
						<ErrorMessage name="firstName" />
					</FormHelperText>
				</FormControl>
				<FormControl fullWidth sx={{ mb: 3 }}>
					<FormLabel sx={{ color: "#fff" }} required>
						{t("Last Name")}
					</FormLabel>

					<TextField
						{...whiteInputProps}
						name="lastName"
						value={formik.values.lastName}
						placeholder={t("Only Greek/English up to 70 characters")}
						onChange={formik.handleChange}
					/>

					<FormHelperText sx={{ color: "#ffd1d1" }}>
						<ErrorMessage name="lastName" />
					</FormHelperText>
				</FormControl>
				<FormControl fullWidth sx={{ mb: 3 }}>
					<FormLabel sx={{ color: "#fff" }} required>
						{t("Email")}
					</FormLabel>

					<TextField
						{...whiteInputProps}
						name="email"
						value={formik.values.email}
						placeholder={t("Email, up to 100 Latin characters")}
						onChange={formik.handleChange}
					/>

					<FormHelperText sx={{ color: "#ffd1d1" }}>
						<ErrorMessage name="email" />
					</FormHelperText>
				</FormControl>
				<FormControl fullWidth sx={{ mb: 3 }}>
					<FormLabel sx={{ color: "#fff" }} required>
						{t("Mobile Phone")}
					</FormLabel>

					<TextField
						{...whiteInputProps}
						name="mobile"
						value={formik.values.mobile}
						placeholder="+30XXXXXXXXXX"
						onChange={formik.handleChange}
					/>

					<FormHelperText sx={{ color: "#ffd1d1" }}>
						<ErrorMessage name="mobile" />
					</FormHelperText>
				</FormControl>
				<FormControl fullWidth sx={{ mb: 2 }}>
					<FormControlLabel
						control={
							<Checkbox
								sx={{
									color: "#fff",
									"&.Mui-checked": { color: "#fff" }
								}}
								checked={formik.values.signupforsnfnews}
								onChange={formik.handleChange}
								name="signupforsnfnews"
							/>
						}
						label={
							<Typography sx={{ color: "#fff", fontSize: 14 }}>
								{t("I want to receive informational messages from the SNF...")}
							</Typography>
						}
					/>
				</FormControl>
				<FormControl fullWidth sx={{ mb: 3 }}>
					<FormControlLabel
						control={
							<Checkbox
								sx={{
									color: "#fff",
									"&.Mui-checked": { color: "#fff" }
								}}
								checked={formik.values.termsofuseagreed}
								onChange={formik.handleChange}
								name="termsofuseagreed"
							/>
						}
						label={
							<Typography sx={{ color: "#fff", fontSize: 14 }}>
								{t("I agree to the")}{" "}
								<Link
									href="https://www.snf.org/el/oroi-hrisis/"
									target="_blank"
									sx={{ color: "#fff", textDecoration: "underline" }}
								>
									{t("Terms of Use")}
								</Link>
							</Typography>
						}
					/>

					<FormHelperText sx={{ color: "#ffd1d1" }}>
						<ErrorMessage name="termsofuseagreed" />
					</FormHelperText>
				</FormControl>
				<Box sx={{ mt: 2, mb: 2,bgcolor:'transparent' }}>
					<ReCAPTCHA
						sitekey="6LeXiicUAAAAAAUWDcgiSy8Q-4xeqfkiVj_42D4S"
						onChange={value => formik.setFieldValue("recaptcha", value)}
					/>
				</Box>
				<LoadingButton
					loading={loading}
					fullWidth
					variant="contained"
					type="submit"
					sx={{
						background: "#fff",
						color: "#004B88",
						mt: 2,
						height: 44,
						borderRadius: 1,
						textTransform: "none",
						fontWeight: 600
					}}
				>
					{t("Continue")}
				</LoadingButton>

				<Button
					fullWidth
					variant="outlined"
					startIcon={<Clear />}
					sx={{
						mt: 2,
						height: 44,
						textTransform: "none",
						borderColor: "rgba(255,255,255,0.7)",
						color: "#fff",
						"&:hover": {
							borderColor: "#fff",
							background: "rgba(255,255,255,0.1)"
						}
					}}
					onClick={() => formik.resetForm()}
				>
					{t("Clear")}
				</Button>

				<Button
					fullWidth
					variant="outlined"
					startIcon={<Home />}
					sx={{
						mt: 2,
						height: 44,
						textTransform: "none",
						borderColor: "rgba(255,255,255,0.7)",
						color: "#fff",
						"&:hover": {
							borderColor: "#fff",
							background: "rgba(255,255,255,0.1)"
						}
					}}
					onClick={() => history.push(getRouteUrl(ROUTE_PAGE_HOME,{campaign}))}
				>
					{t("Home")}
				</Button>
			</Box>
		</FormikProvider>
	);
};

export default Form;
